export default "__VITE_ASSET__CVQFv9MR__"